import React, { Component } from "react";
import CommonListViewScreen from "../../core/pages/CommonListViewScreen";
import { OffhireAPIRoutes } from "../application/apiSources";
import EventCategoryForm from "../forms-dialog/EventCategoryForm";
import { EventCategoryService } from "../services/services";
class EventCategoryScreen extends Component {
  
  render() {
    return (
      <CommonListViewScreen
        serviceModeActive={true}
        entityService={EventCategoryService}
        path={OffhireAPIRoutes.EVENT_CATEGORY}
        dataPreprocessor={{
          mainTitle: "Events Categories",
          path: "/offhire/event-category",
          columns: [
            {  header: "ID", field: "id", width: "10%" },
            {  header: "Name", field: "name", width: "20%" },
            {  header: "Description", field: "description", width: "60%" },
          ]
        }}
        canDelete={true}
      >
        <EventCategoryForm />
      </CommonListViewScreen>
    );
  }
}

export default EventCategoryScreen;
